import { render } from "./GovernmentBondsPage.vue?vue&type=template&id=bcd786d4"
import script from "./GovernmentBondsPage.vue?vue&type=script&lang=js"
export * from "./GovernmentBondsPage.vue?vue&type=script&lang=js"

import "./GovernmentBondsPage.vue?vue&type=style&index=0&id=bcd786d4&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__